//import { graphql, useStaticQuery, Link } from "gatsby";
import React from "react"
import { Link } from "gatsby"

const Footer = () => {
  //const [isExpanded, toggleExpansion] = useState(false);

  return (
    <React.Fragment>
      <footer className="bg-blue-900">
        <nav className="flex justify-between max-w-4xl p-4 mx-auto text-sm md:p-8">
          <p className="text-white">
            Created by{` `}
            <a
              className="font-bold no-underline"
              href="https://ialmanza.com"
              rel="noopener noreferrer"
            >
              Isaac Almanza
            </a>
          </p>
          <p></p>
        </nav>
      </footer>
    </React.Fragment>
  )
}

export default Footer
